import React, { useMemo } from 'react';
import styled from 'styled-components';
import Chart from 'react-apexcharts';

const LongitudinalZoneChart = ({ categories, series, colors, yMax = 100 }) => {
    const options = useMemo(() => ({
        chart: { type: 'bar', stacked: true, toolbar: { show: false }, animations: { enabled: true }, foreColor: '#6b7280' },
        grid: { borderColor: '#e5e7eb', strokeDashArray: 3 },
        dataLabels: { enabled: false },
        xaxis: { categories: categories || [], labels: { rotate: -45, style: { fontWeight: 500 } } },
        yaxis: { max: yMax, labels: { formatter: (v) => `${Math.round(v)}%` }, title: { text: 'Distribution (%)', style: { fontWeight: 600, color: '#4b5563' } } },
        legend: { position: 'top', horizontalAlign: 'left' },
        colors: colors || undefined,
        tooltip: { y: { formatter: (v) => `${Math.round(v)}%` } },
        plotOptions: { bar: { columnWidth: '55%', borderRadius: 2 } },
        fill: { opacity: 0.95 },
    }), [categories, colors, yMax]);

    if (!series || !series.length || !categories || !categories.length) return null;

    return (
        <Wrapper>
            <Chart options={options} series={series} type="bar" height={420} />
        </Wrapper>
    );
};

export default LongitudinalZoneChart;

const Wrapper = styled.div`
    width: 100%;
`;


